var map = {
	"./baccarat/cancel.svg": "75d1",
	"./baccarat/draw.svg": "d44f",
	"./baccarat/meron.svg": "a0c1",
	"./baccarat/suspend.svg": "2e51",
	"./baccarat/wala.svg": "1a14",
	"./flight/cancel.svg": "efe5",
	"./flight/draw.svg": "c5c5",
	"./flight/meron.svg": "8402",
	"./flight/suspend.svg": "7949",
	"./flight/wala.svg": "7cdf",
	"./icons/angular.svg": "9451",
	"./icons/book.svg": "a337",
	"./icons/bootstrap.svg": "2ea3",
	"./icons/brush.svg": "815f",
	"./icons/figma.svg": "7472",
	"./icons/parachute.svg": "666b",
	"./icons/react.svg": "f4d6",
	"./icons/rocket.svg": "df02",
	"./icons/speaker.svg": "1535",
	"./icons/star.svg": "0a83",
	"./icons/toolbox.svg": "40d5c",
	"./icons/vuejs.svg": "57c1",
	"./logo/logo.svg": "ed29",
	"./pages/coming-soon-dark.svg": "c09f",
	"./pages/coming-soon.svg": "7b13",
	"./pages/error-dark.svg": "e0c1",
	"./pages/error.svg": "053b",
	"./pages/forgot-password-v2-dark.svg": "6e2f",
	"./pages/forgot-password-v2.svg": "5b2a",
	"./pages/login-v2-dark.svg": "ff0f",
	"./pages/login-v2.svg": "5aa9",
	"./pages/login/facebook.svg": "4631",
	"./pages/login/github.svg": "7b1ea",
	"./pages/login/google.svg": "74c7",
	"./pages/login/twitter.svg": "ceb3",
	"./pages/not-authorized-dark.svg": "a357",
	"./pages/not-authorized.svg": "e767",
	"./pages/register-v2-dark.svg": "99b7",
	"./pages/register-v2.svg": "67df",
	"./pages/reset-password-v2-dark.svg": "aed4",
	"./pages/reset-password-v2.svg": "ed94",
	"./pages/under-maintenance-dark.svg": "189d",
	"./pages/under-maintenance.svg": "70e7",
	"./result/cancel.svg": "0dc1",
	"./result/draw.svg": "0c2f",
	"./result/meron.svg": "63ba",
	"./result/suspend.svg": "3e68",
	"./result/wala.svg": "9457"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";